<template>
  <v-layout 
		column 
		>
    <v-flex 
			xs12 
			my-1
			pt-4
			mt-5>
      <groups-search-panel />
		</v-flex>
			 <v-flex 
				xs12 
				my-1>
			  <groups-panel />
				</v-flex>
		</v-layout>
</template>

<script>
import GroupsPanel from './GroupsPanel'
import GroupsSearchPanel from './GroupsSearchPanel'
import GroupsService from '@/services/GroupsService'

import { mapState } from 'vuex'
import { ATTR_LIST_B, ATTR_LIST_R, ATTR_LIST_RSMP, SCHOOL, SPORTS, SD, BUSINESS } from '@/components/globals/consts'

export default {
	components: {
		GroupsPanel,
		GroupsSearchPanel,
	},
	data () {
		return {
			groups: null,
			groupsRoute: {'name': 'groups'},
			clientsRoute: {'name': 'clients'},
			attrList: null,
			loaded: false
		}
	},
	computed: {
		...mapState([
			'isUserLoggedIn',
			'testType'
		])
	},
  async created() {
    if (this.testType === BUSINESS || this.testType === SPORTS || this.testType ===SCHOOL) { 
        this.attrList = ATTR_LIST_B.sort()
      }
      else if (this.testType === SD) {
        this.attrList = ATTR_LIST_R.sort()
      }
    //   else if (this.testType === SCHOOL ){
    //     //this.attrList = ATTR_LIST_RSMP.sort()
    //   }
  },
	async mounted () {
		if (!this.isUserLoggedIn) {
			this.$router.push({
				name: 'login'
			})
		}
		this.groups = (await GroupsService.index()).data
	},
	async beforeDestroy() {
    try {
			this.groups = null //.destroy()
			this.attrList = null //.destroy()
      //delete this._chart;
    } catch (err) {
      console.log(err);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Groups/GroupsIndex.vue